import { SvgIcon as MuiSvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

/**
 * A functional component that renders an SVG icon using the Material-UI SvgIcon component.
 *
 * @param {SvgIconProps} props - The properties passed to the SvgIcon component.
 * @returns {JSX.Element} The rendered SVG icon component.
 */
export const SvgIcon = (props: SvgIconProps) => <MuiSvgIcon {...props} />;
